import { defineMessages } from 'react-intl';

export const scope = 'app.components.CreateStorePopup';

export default defineMessages({
  warningTitle: {
    id: `${scope}.warningTitle`,
    defaultMessage: 'Vui lòng chọn địa chỉ đúng với khu vực: {region}',
  },
  warningDescription: {
    id: `${scope}.warningDescription`,
    defaultMessage: 'Hãy chắc chắn vị trí trên bản đồ được ghim đúng bạn nhé!',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Không thể tìm thấy vị trên bản đồ',
  },
  addressPinInfo: {
    id: `${scope}.addressPinInfo`,
    defaultMessage: 'Địa chỉ của bạn ở đây',
  },
  proposedLocation: {
    id: `${scope}.proposedLocation`,
    defaultMessage: 'Địa chỉ đề xuất',
  },
  optionTitle: {
    id: `${scope}.optionTitle`,
    defaultMessage: 'Chọn địa chỉ bên dưới',
  },
  optionOpenExtendedMap: {
    id: `${scope}.optionOpenExtendedMap`,
    defaultMessage: 'Chọn trên bản đồ',
  },
  openExtendedMap: {
    id: `${scope}.openExtendedMap`,
    defaultMessage: 'Xem bản đồ',
  },
  locationAddressConfirm: {
    id: `${scope}.locationAddressConfirm`,
    defaultMessage: 'Xác nhận vị trí trên bản đồ',
  },
  storeLocationConfirm: {
    id: `${scope}.storeLocationConfirm`,
    defaultMessage: 'Vui lòng xác nhận địa chỉ của bạn',
  },
  storeLocationConfirmDescription: {
    id: `${scope}.storeLocationConfirmDescription`,
    defaultMessage: 'Vị trí trên bản đồ phải khớp với địa chỉ của bạn để thuận tiện giao hàng',
  },
  confirm: {
    id: `${scope}.confirm`,
    defaultMessage: 'Xác nhận',
  },
  notConfirm: {
    id: `${scope}.notConfirm`,
    defaultMessage: 'Thay đổi',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Hủy',
  },
  selectPin: {
    id: `${scope}.selectPin`,
    defaultMessage: 'Chọn địa chỉ này',
  },
  suggestSelectAddress: {
    id: `${scope}.suggestSelectAddress`,
    defaultMessage: 'Vui lòng chọn từ danh sách gợi ý để xác nhận địa chỉ cửa hàng',
  },
  taxCode: {
    id: `${scope}.taxCode`,
    defaultMessage: 'Mã số thuế',
  },
  taxCodePlaceHolder: {
    id: `${scope}.taxCodePlaceHolder`,
    defaultMessage: 'Nhập mã số thuế',
  },
  companyName: {
    id: `${scope}.companyName`,
    defaultMessage: 'Tên công ty',
  },
  companyNamePlaceHolder: {
    id: `${scope}.companyNamePlaceHolder`,
    defaultMessage: 'Nhập tên công ty',
  },
  emailReceiveRedInvoice: {
    id: `${scope}.emailReceiveRedInvoice`,
    defaultMessage: 'Email để nhận hóa đơn điện tử',
  },
  emailReceiveRedInvoicPlaceHolder: {
    id: `${scope}.emailReceiveRedInvoicPlaceHolder`,
    defaultMessage: 'Nhập email để nhận hóa đơn điện tử',
  },
  redInvoiceAddress: {
    id: `${scope}.redInvoiceAddress`,
    defaultMessage: 'Địa chỉ',
  },
  redInvoiceAddressPlaceHolder: {
    id: `${scope}.redInvoiceAddressPlaceHolder`,
    defaultMessage: 'Nhập địa chỉ',
  },
  redInvoiceAddressCheckbox: {
    id: `${scope}.redInvoiceAddressCheckbox`,
    defaultMessage: 'Địa chỉ xuất hoá đơn trùng với địa chỉ nhận hàng',
  },
  taxCodeInvalid: {
    id: `${scope}.taxCodeInvalid`,
    defaultMessage: 'Mã số thuế không hợp lệ',
  },
  emailInvalid: {
    id: `${scope}.emailInvalid`,
    defaultMessage: 'Email không hợp lệ',
  },
  pleaseFillOutThisField: {
    id: `${scope}.pleaseFillOutThisField`,
    defaultMessage: 'Vui lòng không để trống',
  },
  fetchInvoiceFail: {
    id: `${scope}.fetchInvoiceFail`,
    defaultMessage: 'Không tìm thấy thông tin cho mã số thuế này. Vui lòng kiểm tra lại!',
  },
  invalidPhoneNumber: {
    id: `${scope}.invalidPhoneNumber`,
    defaultMessage: 'Số điện thoại không đúng định dạng',
  },
  redInvoiceInfo: {
    id: `${scope}.redInvoiceInfo`,
    defaultMessage: 'Thông tin xuất hoá đơn',
  },
  storeInfo: {
    id: `${scope}.storeInfo`,
    defaultMessage: 'Thông tin cửa hàng',
  },
  storeConfirmInfo: {
    id: `${scope}.storeConfirmInfo`,
    defaultMessage: 'Xác nhận địa chỉ cửa hàng',
  },
  messageForEmail: {
    id: `${scope}.messageForEmail`,
    defaultMessage:
      'Có thể nhập nhiều email, các email cách nhau bằng dấu phẩy. Ví dụ: email1@congty.com, email2@congty.com',
  },
  purchaserName: {
    id: `${scope}.purchaserName`,
    defaultMessage: 'Họ tên người mua hàng',
  },
  purchaserNamePlaceHolder: {
    id: `${scope}.purchaserNamePlaceHolder`,
    defaultMessage: 'Nhập họ tên người mua hàng',
  },
});
